import { Component, Input } from '@angular/core';
import { Leg } from '@ridango/components';

@Component({
    selector: 'rwidget-leg-walk',
    templateUrl: './leg-walk.component.html'
})
export class LegWalkComponent {
    @Input() leg: Leg;
    @Input() isDestination: boolean = false;

    public get destinationText(): string {
        return this.isDestination ? 'ITINERARY_INSTRUCTIONS_TO_DESTINATION' : 'ITINERARY_INSTRUCTIONS_TO_BUS_STOP';
    }
}
